import { Badge, type BadgeTone } from '@/components/ui/Badge';

import { PAYMENT_STATE_LABEL, type PaymentState } from '../../schemas/invoice.schema';

const TONE: Record<PaymentState, BadgeTone> = {
  unpaid: 'danger',
  partly: 'warning',
  paid: 'success',
  cancelled: 'neutral',
};

export interface InvoicePaymentBadgeProps {
  state: PaymentState;
}

/** Where a bill stands. Colour is never the only signal — the word is always there too. */
export function InvoicePaymentBadge({ state }: InvoicePaymentBadgeProps) {
  return (
    <Badge tone={TONE[state]} dot>
      {PAYMENT_STATE_LABEL[state]}
    </Badge>
  );
}
